<template lang="pug">
  .Paragraph.Paragraph-margin.ParagraphSound

    .ParagraphSound_wrapper(@click="toggle")
      .ParagraphSound_btn
        RadialProgress(
          :progress="progress"
          :diameter="62"
          :placeholderStrokeWidth="1"
          :progressStrokeWidth="4"
        )

        .ParagraphSound_ico.ParagraphSound_ico-pause(v-if="isPlaying" key="pause")
          SvgInline(src="pause")

        .ParagraphSound_ico.ParagraphSound_ico-play(v-if="!isPlaying" key="play")
          SvgInline(src="play")

      p.ParagraphSound_title {{item.soundTitle}}

</template>

<script>

import scrollUpdate from '@/mixins/scrollUpdate'
import SvgInline from '@/components/SvgInline'
import RadialProgress from '@/components/RadialProgress'
import {Howl, Howler} from 'howler'
import raf from 'raf'
import { mapGetters , mapActions } from "vuex"

export default {
  props: ['item'],
  mixins: [scrollUpdate],
  components: { SvgInline, RadialProgress },
  data () {
    return {
      isPlaying: false,
      currentTime: 0,
      totalTime: 0
    }
  },
  computed: {
    ...mapGetters(['audioPlayerStatePodcast']),
    progress () {
      return this.currentTime / this.totalTime || 0
    }
  },
  watch: {
    isPlaying () {
      if (this.isPlaying) {
        this.play()
      } else {
        this.pause()
      }
    },
    audioPlayerStatePodcast() {
      if (this.audioPlayerStatePodcast) {
        this.isPlaying = false
      }
    }
  },
  mounted () {
    this.createSound()

    document.addEventListener('visibilitychange', this.globalVisibilityChangeHandler, false)
  },
  beforeDestroy () {
    this.stop()

    document.removeEventListener('visibilitychange', this.globalVisibilityChangeHandler)
  },
  methods: {
    ...mapActions(["updateAudioPlayerState"]),
    /**
     * Gère si le son devrait être en train de jouer
     * en fonction de si la fenêtre est focus ou non
     */
    globalVisibilityChangeHandler () {
      if (document.visibilityState == 'hidden' && this.isPlaying) {
        this._pausedByDocumentVisibility = true
        this.pause()
      } else if (document.visibilityState == 'visible' && this._pausedByDocumentVisibility) {
        this._pausedByDocumentVisibility = false
        this.play()
      }
    },
    /**
     * Création de l'objet "son"
     */
    createSound () {
      // TODO - utiliser `this.item.soundURL` une fois que ça fonctionne
      this._sound = new Howl({
        src: [this.item.sound],
        onend: () => {
          this.stop()
        },
        onload: () => {
          this.totalTime = this._sound.duration()
        }
      })
    },
    /**
     * Toggle play/pause le son
     */
    toggle () {
      this.isPlaying = !this.isPlaying
    },
    /**
     * On lance le RAF permettant de calculer la progression du son
     */
    startListeningForProgress () {
      // this._progressRAF = raf(this.onProgress)
    },
    /**
     * On arrête le RAF permettant de calculer la progression du son
     */
    stopListeningForProgress () {
      // raf.cancel(this._progressRAF)
    },
    /**
     * Progress event RAF
     */
    onProgress (p, pv) {
      // this.currentTime = this._sound.seek()
      // this._progressRAF = raf(this.onProgress)
    },
    onEnter () {
      this.$el.classList.add('is-visible')
    },
    onExit () {
      this.$el.classList.remove('is-visible')
    },
    /**
     * Joue le son
     */
    play () {
      this._sound.play()
      this.stopListeningForProgress() // au cas où, pour éviter un double raf
      this.startListeningForProgress()
      this.updateAudioPlayerState( { 
        name : 'paragraph',
        data : true 
      })
    },
    /**
     * Pause le son à la position actuel
     */
    pause () {
      this._sound.pause()
      this.stopListeningForProgress()
      this.updateAudioPlayerState( { 
        name : 'paragraph',
        data : false 
      })
    },
    /**
     * Arrête le son et le remet au début
     */
    stop () {
      this._sound.stop()
      this.stopListeningForProgress()
      this.updateAudioPlayerState( { 
        name : 'paragraph',
        data : false 
      })
    }
  }
}

</script>

<style lang="stylus" scoped>

.ParagraphSound
  width 100%
  padding 0 20px

  &_wrapper
    padding 30px
    width 100%
    max-width: 1100px
    position relative
    box-sizing border-box
    background-color $black
    text-align center
    display flex
    flex-direction row
    justify-content space-between
    align-items center
    color $beige
    cursor pointer

    @media $mq_m
      padding 40px 50px

    &:after
      border_distance = 10px
      content ''
      position absolute
      top border_distance
      left border_distance
      right border_distance
      bottom border_distance
      border 1px solid transparent
      transition all 0.8s 0.5s $ease

    &:hover
      .ParagraphSound_btn
        .RadialProgress
          color: transparent

      .ParagraphSound_ico
        background-color $beige
        color $black

        &-play
          transform rotateZ(120deg)

  &_btn
    position: relative
    opacity 0
    transition all 0.8s 0.5s $ease
    transform scale(0.3)

    .RadialProgress
      position: absolute
      top 50%
      left 50%
      transform translate(-50%,-50%)
      transition color 0.8s $ease

  &_ico
    width 60px
    height 60px
    border-radius 50%
    display flex
    align-items center
    flex-direction column
    justify-content center
    color: $beige
    transition all 0.8s $ease

    svg
      width 15px
      position relative

    &-play
      svg
        left 2px

  p
    flex-grow: 1
    font-size: 14px;
    line-height: 28px;
    letter-spacing 5px
    opacity 0
    margin auto
    transition all 0.8s 0.5s $ease
    margin-left 0px
    text-transform uppercase
    text-align: center;

    @media $mq_m
      font-size: 18px;
      line-height: 35px;

  &.is-visible

    .ParagraphSound_btn

      opacity 1
      transform scale(1)

    .ParagraphSound_wrapper:after

      border-color $beige

    p

      opacity 1
      letter-spacing 1px

</style>
